<ng-template #modal let-modal>
  <div [zeroLoadingIndicator]="editOrderFacade.orderCancelling$ | async" [description]="'order.edit.cancelling' | transloco">
    <web-design-system-modal [headline]="'order.edit.header' | transloco" (dismiss)="close()">
      <div class="d-flex align-items-center justify-content-between">
        <div>{{ order.assetName }}</div>
        <div class="font-bold">{{ quote | currency }}</div>
      </div>
      <hr />
      <div class="current">
        <div class="mb-2 label font-bold">{{ 'order.edit.current' | transloco }}</div>
        <div class="d-flex align-items-center justify-content-between">
          <div class="label">{{ order.direction | displayLabel }}</div>
          <div class="font-bold">{{ order.quantity }} {{ 'order.edit.labels.qty' | transloco }}</div>
        </div>
        <hr />
        @switch (order.execType) {
          @case ('limit') {
            <div class="d-flex align-items-center justify-content-between">
              <div class="label">{{ 'order.edit.labels.limit' | transloco }}</div>
              <div class="font-bold">{{ order.limitPrice | currency }}</div>
            </div>
          }
          @case ('stop') {
            <div class="d-flex align-items-center justify-content-between">
              <div class="label">{{ 'order.edit.labels.stop' | transloco }}</div>
              <div class="font-bold">{{ order.stopPrice | currency }}</div>
            </div>
          }
          @case ('stoplimit') {
            <div class="d-flex align-items-center justify-content-between">
              <div class="label">{{ 'order.edit.labels.stop' | transloco }}</div>
              <div class="font-bold">{{ order.stopPrice | currency }}</div>
            </div>
            <hr />
            <div class="d-flex align-items-center justify-content-between">
              <div class="label">{{ 'order.edit.labels.limit' | transloco }}</div>
              <div class="font-bold">{{ order.limitPrice | currency }}</div>
            </div>
          }
        }
      </div>
      <div class="mt-2 mb-1">
        <web-components-user-messages />
      </div>
      @if (editOrderFacade.isReady$ | async) {
        <div class="mt-4 mb-1">
          @if (editOrderFacade.isOutOfTradingTimes$ | async) {
            <div class="label text-color-error">
              {{ 'order.edit.out-of-trading-hours' | transloco }}
            </div>
          } @else {
            <div class="label font-bold text-color-error">{{ 'order.edit.hint.headline' | transloco }}</div>
            <div class="label text-color-error">
              {{ 'order.edit.hint.text' | transloco }}
            </div>
          }
          <ng-template #hint>
            <div class="label font-bold text-color-error">{{ 'order.edit.hint.headline' | transloco }}</div>
            <div class="label text-color-error">
              {{ 'order.edit.hint.text' | transloco }}
            </div>
          </ng-template>
        </div>
      }
      <div class="mt-4">
        <web-design-system-button
          [disabled]="
            (editOrderFacade.orderCancelling$ | async) ||
            (editOrderFacade.isReady$ | async) === false ||
            (editOrderFacade.isOutOfTradingTimes$ | async)
          "
          (click)="editOrderFacade.cancelOrder(order.orderId)"
          [fullwidth]="true"
        >
          {{ 'order.edit.confirm' | transloco }}
        </web-design-system-button>
      </div>
    </web-design-system-modal>
  </div>
</ng-template>
